// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__YZbT-","logo":"nav_logo__WXCyG"};